import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

import { TableSubviewState } from './table-subview.types';

export const TableSubviewStateContext = createContext<TableSubviewState | undefined>(undefined);

interface TableSubviewStateProviderProps extends TableSubviewState {
  children?: ReactNode;
}

export const TableSubviewStateProvider = (props: TableSubviewStateProviderProps) => {
  const { children, onSelectionChanged } = props;
  const [selectedId, setSelectedId] = useState<string | undefined>(props.selectedId);

  const value = useMemo(() => {
    return {
      selectedId,
      onSelectionChanged: (id: string) => {
        setSelectedId(id);
        onSelectionChanged(id);
      },
    };
  }, [selectedId, onSelectionChanged]);

  return <TableSubviewStateContext.Provider value={value}>{children}</TableSubviewStateContext.Provider>;
};

export const useTableSubviewState = () => {
  const context = useContext(TableSubviewStateContext);
  if (context === undefined) {
    throw new Error('useTableSubviewState must be within TableSubviewStateProvider');
  }

  return context;
};
